import * as React from 'react';
import { SVGProps } from 'react';

const IconWrenchSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M8.875 5.017a3.168 3.168 0 0 1 .808-3.092 3.168 3.168 0 0 1 3.068-.814l-1.793 1.793.192 1.946 2.037.28 1.794-1.792a3.166 3.166 0 0 1-4.043 3.838l-.01.01-7.377 7.376a1.493 1.493 0 0 1-2.113 0 1.495 1.495 0 0 1 0-2.114l7.437-7.43Z" />
  </svg>
);
export default IconWrenchSizeS;
